import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('GenerateJournalController', GenerateJournalController);

    function GenerateJournalController() {
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/generate-journal/generate-journal.controller.ts